export default "__VITE_ASSET__Cp$lfOxb__"